/**
 * Created by scuzzort3 on 8/11/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('CommunitiesDropDownController', CommunitiesDropDownController);

    CommunitiesDropDownController.$inject = ['$element', '$scope', 'authentication'];

    function CommunitiesDropDownController($element, $scope, authentication) {
        var vm = this;
        vm.searchText = "";
        $scope.onCommunityClick = $scope.onCommunityClick();
        vm.showArchivedNodes = $scope.showInactive;
        vm.showLeafNodes = $scope.showLeafs;
        vm.disabledCommunityId = $scope.disabledCommunityId;
        vm.firstRender = $scope.startCollapsed;

        if(vm.showArchivedNodes === "true"){
            vm.showArchivedNodes = true;
        }
        else{
            vm.showArchivedNodes = false;
        }

        if(vm.showLeafNodes === "false"){
            vm.showLeafNodes = false;
        }
        else{
            vm.showLeafNodes = true;
        }

        $scope.$watch("refreshFlag",function(newValue,oldValue) {
            if(newValue === true) {
                $scope.refreshFlag = false;
                getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
            }
        });

        $scope.$watch("searchText",function(newValue,oldValue) {
            if(newValue !== undefined){
                vm.searchText = newValue;
                getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
            }
        });

        vm.changeBackgroundColor = changeBackgroundColor;
        vm.onClickExpandCollapse = onClickExpandCollapse;
        vm.onClickCommunityNode = onClickCommunityNode;
        vm.getIconNameForNode = getIconNameForNode;
        vm.isSelectedNode = isSelectedNode;
        vm.searchText = "";
        vm.communities = [];
        vm.isLoading = true;
        vm.nodeDataHasChanged = false;

        vm.isCommunitySelected = false;
        vm.selectedCommunity = null;

        vm.selectedCommunityName = "";
        vm.selectedCommunityIsLeaf = false;
        vm.selectedCommunityIsArchived = false;
        vm.selectedCommunityParentName = "";

        vm.search = function (searchText) {
            getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
        };

        function changeBackgroundColor(element) {
            element.css('background-color', "gray");
        }

        function onClickExpandCollapse(communityNode) {
            if (communityNode.children !== null || communityNode.children.length > 0) {
                if (communityNode.hideChildren === true) {
                    communityNode.hideChildren = false;
                }
                else {
                    communityNode.hideChildren = true;
                }
            }
        }

        function onClickCommunityNode(communityNode) {
            $scope.onCommunityClick(communityNode);
        }

        function getIconNameForNode(communityNode) {
            // if we have no children, use a dot
            if (communityNode.isLeaf === 1) {
                return "fa-circle";
            }
            else if (communityNode.hideChildren === true) {
                return "fa-plus";
            }
            else {
                return "fa-minus";
            }
        }

        function getCommunityDataWithFilter(filter, collapseAll) {
            vm.communities = [];
            vm.isLoading = true;
            vm.nodeDataHasChanged = false;
            vm.isCommunitySelected = false;
            vm.selectedCommunity = null;

            authentication.getCommunitiesWithArchives()
                .then(function (result) {
                    vm.communities = [makeTreeViewFromCommunities(result, filter)];
                    vm.firstRender = collapseAll;
                });
        }

        function makeTreeViewFromCommunities(communitiesJson, filter) {
            var listEntry = {
                value: communitiesJson.value,
                id: communitiesJson.id,
                isArchived: communitiesJson.isArchived,
                isLeaf: communitiesJson.isLeaf,
                children: [],
                parent: null
            };

            listEntry.children = recursiveMakeCommunityHtml(communitiesJson.children, communitiesJson, vm.searchText).children;
            return listEntry;
        }

        function recursiveMakeCommunityHtml(childrenArray, parent, filter) {
            // NOTE: This function actually builds the tree, it also takes into account
            // filter text, and ensure that parents of nodes that should not be filtered
            // will still appear

            // create this level's list (NOTE: this list may or may not end up empty)
            var retList = [];

            // this flag determines if this level has any un-filtered information
            var hasUnfilteredChildren = 0;
            childrenArray.forEach(function (elem) {

                var listEntry = {
                    value: elem.value,
                    id: elem.id,
                    isArchived: elem.isArchived,
                    isLeaf: elem.isLeaf,
                    children: [],
                    hideChildren: vm.firstRender,
                    parent: parent
                };

                var shouldShowNode = true;

                if(elem.isArchived === 1){
                    shouldShowNode = vm.showArchivedNodes;
                }

                if(elem.isLeaf === 1){
                    shouldShowNode = vm.showLeafNodes;
                }

                if(shouldShowNode === true){
                    // this flag tells us if any of our children have unfiltered data in them
                    // this node should be shown in one of two instances
                    // 1) A child of this node matches the filter (see below)
                    // 2) This node itself matches the filter
                    var hasNestedChildren = 0;
                    if (elem.children !== null && elem.children.length !== 0) {
                        // get child info
                        var nestedChildrenInfo = recursiveMakeCommunityHtml(elem.children, elem, filter);
                        if (nestedChildrenInfo.hasUnfilteredChildren == 1) {
                            // if a child node of this node has unfiltered info, then make it collapsable
                            // set our nested children flag
                            hasNestedChildren = 1;
                            listEntry.children = nestedChildrenInfo.children;
                        }
                    }

                    // This if statement check for 3 things
                    // 1) If condition #2 is true -> this node matches the filter
                    // 2) If the filter is blank
                    // 3) If this node should be included because a child node matches the filter
                    // if any one of these statements are true, then the entry should be added to the list
                    // and we should set the hasUnfilteredChildren flag so parent calls will know to include
                    // this node in the tree
                    if (filter === "" || elem.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || hasNestedChildren == 1) {
                        hasUnfilteredChildren = 1;
                        retList.push(listEntry);
                    }
                }
            });

            return {
                hasUnfilteredChildren: hasUnfilteredChildren,
                children: retList
            };
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }

        function onSubmit() {
            $modalInstance.close(vm.communitySelected);
        }

        function isSelectedNode(communityNode) {
            if (vm.selectedCommunity !== null) {
                if (communityNode.id == vm.selectedCommunity.id) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
})();